export const cibMagento = ["32 32","<path d='M16 32l-5.937-3.427v-16l3.959-2.287v16l1.979 1.203 1.979-1.203v-16l3.964 2.287v16zM29.855 8v16l-3.959 2.287v-16l-9.896-5.713-9.901 5.713v16l-3.953-2.287v-16l13.855-8z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-magento.js
// module id = null
// module chunks = 